import {
    ADD_NOTIFICATION_FAIL,
    ADD_NOTIFICATION_SUCCESS,
    DELETE_NOTIFICATION_FAIL,
    DELETE_NOTIFICATION_SUCCESS,
    EXPORT_NOTIFICATION_FAIL,
    EXPORT_NOTIFICATION_SUCCESS,
    GET_NOTIFICATION_DETAILS_FAIL,
    GET_NOTIFICATION_DETAILS_SUCCESS,
    GET_NOTIFICATION_LISTING_FAIL,
    GET_NOTIFICATION_LISTING_SUCCESS,
    RESET_NOTIFICATION_ACTION_STATE,
    RESET_NOTIFICATION_STATE,
    UPDATE_NOTIFICATION_FAIL,
    UPDATE_NOTIFICATION_SUCCESS,
    READ_NOTIFICATION_SUCCESS,
    READ_NOTIFICATION_FAIL,
    READ_ALL_NOTIFICATION_SUCCESS,
    READ_ALL_NOTIFICATION_FAIL
} from "./actionTypes"

const INIT_STATE = {
    notificationListing: [],
    notificationDetails: [],
    addNotification: [],
    updateNotification: [],
    deleteNotification: [],
    exportNotification: [],
    readNotification: [],
    readAllNotification: [],
    error: [],
}

const Notification = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_NOTIFICATION_LISTING_SUCCESS:
            return {
                ...state,
                notificationListing: action.payload
            }
        case GET_NOTIFICATION_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_NOTIFICATION_DETAILS_SUCCESS:
            return {
                ...state,
                notificationDetails: action.payload
            }
        case GET_NOTIFICATION_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_NOTIFICATION_SUCCESS:
            return {
                ...state,
                addNotification: action.payload
            }
        case ADD_NOTIFICATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_NOTIFICATION_SUCCESS:
            return {
                ...state,
                updateNotification: action.payload
            }
        case UPDATE_NOTIFICATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_NOTIFICATION_SUCCESS:
            return {
                ...state,
                deleteNotification: action.payload
            }
        case DELETE_NOTIFICATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_NOTIFICATION_SUCCESS:
            return {
                ...state,
                exportNotification: action.payload
            }
        case EXPORT_NOTIFICATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case READ_NOTIFICATION_SUCCESS:
            return {
                ...state,
                readNotification: action.payload,
            }
        case READ_NOTIFICATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case READ_ALL_NOTIFICATION_SUCCESS:
            return {
                ...state,
                readAllNotification: action.payload,
            }
        case READ_ALL_NOTIFICATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_NOTIFICATION_STATE:
            return {
                ...state,
                notificationListing: [],
                notificationDetails: [],
                addNotification: [],
                updateNotification: [],
                deleteNotification: [],
                exportNotification: [],
                readNotification: [],
                readAllNotification: [],
                error: [],
            }
        case RESET_NOTIFICATION_ACTION_STATE:
            return {
                ...state,
                exportNotification: [],
                readNotification: [],
                readAllNotification: [],
                notificationDetails: [],
                error: [],
            }

        default:
            return state
    }
}

export default Notification
